<template id="subscription-form">
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <strong>Subscriber</strong>
                    </div>
                    <b-form>
                        <b-form-group validated
                                label="Name"
                                label-for="subscriberName"
                                description="Please enter name."
                                :label-cols="3"
                                :horizontal="true">
                            <b-form-input id="subscriberName" type="text" placeholder="Enter Name.." v-model="subscriber.name" required autocomplete="name"></b-form-input>
                        </b-form-group>
                        <b-form-group validated
                                label="Surname"
                                label-for="subscriberSurname"
                                description="Please enter surname."
                                :label-cols="3"
                                :horizontal="true">
                            <b-form-input id="subscriberSurname" type="text" placeholder="Enter Surname.." v-model="subscriber.surname" autocomplete="surname"></b-form-input>
                        </b-form-group>
                        <b-form-group validated
                                label="Email"
                                label-for="horizEmail"
                                description="Please enter email."
                                :label-cols="3"
                                :horizontal="true">
                            <b-form-input  id="horizEmail" type="email" placeholder="Enter Email.." v-model="subscriber.email" required autocomplete="username email"></b-form-input>
                        </b-form-group>
                        <b-form-group validated
                                      label="Mobile"
                                      label-for="subscriberMobile"
                                      description="Please enter mobile."
                                      :label-cols="3"
                                      :horizontal="true">
                            <b-form-input id="subscriberMobile" type="text" placeholder="Enter Mobile.." v-model="subscriber.mobile" autocomplete="mobile"></b-form-input>
                        </b-form-group>
                        <div slot="footer">
                            <b-button type="button" size="sm" variant="primary" v-on:click="addSubscriber" v-show="addOption"><i class="fa fa-dot-circle-o" ></i>Add</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {Subscriber} from "../../../models/NewsLetter/Subscriber"
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {handleErrors} from "../../../shared/utils";

    const SubscriptionRepo = RepositoryFactory.get('newsletterSubscribe')

    export default {
        name: 'subscription-form',
        components: {VueLoading},
        props: {
            listingId: {
                type: String,
                default: '',
            },
            subscriber: {
                type: Subscriber,
                default: new Subscriber(),
            },
            addOption: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            addSubscriber() {
                this.isLoading = true
                SubscriptionRepo.createSubscription(this.listingId,
                    {
                        'customer' : {
                            name: this.subscriber.name,
                            surname: this.subscriber.surname,
                            email: this.subscriber.email,
                            mobile: this.subscriber.mobile,
                        }
                }).then(
                    response => (
                        this.isLoading = false,
                        this.$emit('clicked', response.data.data),
                        this.flash('Subscription has been created', 'success')
                    )
                ).catch(
                    response => (
                        handleErrors(response).forEach(
                            value => {
                                this.flash(value,'error')
                            }
                        ),
                        this.isLoading = false
                    )
                )
            }
        }
    }
</script>
